import { Modal, ModalBackdrop, ModalContent } from "@gluestack-ui/themed";
import { forwardRef, useImperativeHandle, useState } from "react";
import { DrawerProps, IModalRefProps } from "./types";

export const Drawer = forwardRef(function Drawer(
  { children, xOffset = 0, width }: DrawerProps,
  ref
) {
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(
    ref,
    (): IModalRefProps => ({
      open: () => setIsOpen(true),
      close: () => setIsOpen(false)
    }),
    []
  );

  return (
    <Modal
      left={xOffset}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      overflow="hidden"
      position="absolute"
      top={0}
    >
      <ModalBackdrop />

      <ModalContent
        height={"$100vh"}
        position="absolute"
        width={width}
        left={0}
        top={0}
        marginRight={"auto"}
        borderRadius={0}
        backgroundColor="$white"
      >
        {children}
      </ModalContent>
    </Modal>
  );
});
